exports.formatQuantityToLocale = function formatQuantityToLocale(quantity){
    return Number.parseInt(quantity).toLocaleString('it-IT');
}

exports.isTextLongerThan = function isTextLongetThan(text, length){
    return text.length > length;
}
